
import {Component, Prop, Vue} from "vue-property-decorator";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IApp} from "@/interfaces/app.interface";
import {IBook} from "@/interfaces/book.interface";
import {IAppState} from "@/interfaces/app-state.interface";

@Component({})
export default class TarifFields extends Vue {
  dateFormats = IApp.DateFormats;
  pickerOptions = IApp.DatePickerOptions.Simple;

  get storeState(): IAppState { return this.$store.state; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get viewMode() { return !this.userAccess.scCarMk; }

  get tarifs() { return this.storeState.book.books[IBook.BookName.tarifs]; }

  get tarifId() { return this.formModel.tarifId; }
  set tarifId(value) {
    this.$store.commit('car/setFormProperty', {
      formName: 'formModel',
      name: 'tarifId',
      value
    });
  };
  get dateBegTarif() { return this.formModel.dateBegTarif; }
  set dateBegTarif(value) {
    this.$store.commit('car/setFormProperty', {
      formName: 'formModel',
      name: 'dateBegTarif',
      value
    });
  };

  changeTarifId() {
    if (this.formModel.tarifId && !this.formModel.dateBegTarif) {
      this.dateBegTarif = new Date();
    }
    this.$emit('formItemChange');
  }
}
